export default "__VITE_ASSET__CUioAdMR__"